import * as $ from 'jquery';
import { forEach } from 'lodash';
import 'jquery.event.pointertouch'; // IMPORTANT: makes available additional properties for TOUCH events

const ie10events = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp', 'MSPointerCancel'];

forEach(ie10events, eventName => (($ as any).event.fixHooks[eventName] = ($ as any).event.mouseHooks));
